import { useState } from "react";
import { Download, Trash2, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { loyaltyExport, loyaltyDeleteAccount } from "../../lib/api";
import { LegalLinks } from "../legal/LegalBits";

export function MyDataCard({ onDeleted }) {
  const [busy, setBusy] = useState("");
  const download = async () => {
    setBusy("export");
    try {
      const data = await loyaltyExport();
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `pozzo-dei-giganti-miei-dati-${new Date().toISOString().slice(0, 10)}.json`;
      a.click();
      URL.revokeObjectURL(a.href);
      toast.success("Dati scaricati");
    } catch { toast.error("Download non riuscito, riprova"); }
    finally { setBusy(""); }
  };
  const remove = async () => {
    if (!window.confirm("Cancellare definitivamente il tuo account Amico dei Giganti?\n\nPerderai il credito accumulato e i tuoi dati personali verranno rimossi o resi anonimi. L'operazione non si può annullare.")) return;
    setBusy("delete");
    try { await loyaltyDeleteAccount(); toast.success("Account cancellato. Ci mancherai!"); onDeleted?.(); }
    catch { toast.error("Cancellazione non riuscita, scrivici a ilpozzodeigiganti@gmail.com"); }
    finally { setBusy(""); }
  };
  return (
    <div className="rounded-2xl border border-[#e8dcc8] bg-[#fbf6ef] p-4" data-testid="loyalty-my-data">
      <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-[#7c5a4e] mb-2"><ShieldCheck className="h-3.5 w-3.5" /> I miei dati e privacy</div>
      <p className="text-xs text-[#5a3d33] mb-3">Sono tuoi: puoi scaricarli in qualsiasi momento o cancellare l'account con un tocco, come previsto dal GDPR.</p>
      <div className="flex flex-wrap gap-2">
        <button onClick={download} disabled={!!busy} className="inline-flex items-center gap-1.5 rounded-full bg-white border border-[#e8dcc8] px-3 py-1.5 text-xs font-semibold text-[#4a1c17] hover:border-[#C48B31] disabled:opacity-60" data-testid="loyalty-export-btn">
          {busy === "export" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Download className="h-3.5 w-3.5" />} Scarica i miei dati
        </button>
        <button onClick={remove} disabled={!!busy} className="inline-flex items-center gap-1.5 rounded-full bg-white border border-red-200 px-3 py-1.5 text-xs font-semibold text-red-700 hover:bg-red-50 disabled:opacity-60" data-testid="loyalty-delete-btn">
          {busy === "delete" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Trash2 className="h-3.5 w-3.5" />} Cancella il mio account
        </button>
      </div>
      <LegalLinks className="mt-3 justify-start" />
    </div>
  );
}
